import React, { useState } from "react"

import NoMorePacksPopup from "./"

import { PageTitle, SectionTitle, Block, BlockTitle } from "@sandbox/Sandbox"
import Kiosk from "@ui/Kiosk"

const Sandbox: React.FC = () => {
  const [ show, setShow ] = useState(false)

  return <>
    <SectionTitle>
      NoMorePacksPopup <a onClick={() => setShow(true)}>SHOW!</a>
    </SectionTitle>
    <Kiosk>
      {show && <NoMorePacksPopup closePopup={() => setShow(false)} />}
    </Kiosk>
  </>
}

export default ["Popups", Sandbox]
